export default __webpack_public_path__ + "static/media/velox.a4125210.png";